import type { RowData } from "@tanstack/react-table";
import { toDisplayText } from "./cellValues";
import { EmptyCellValue } from "./EmptyCellValue";
import { SearchableText } from "./SearchableText";
import type { DataGridCellProps } from "./types";

/** Default cell for text values: search highlights and the column's overflow rule. */
export const TextCell = <TData extends RowData>({
    context,
    meta,
}: Readonly<DataGridCellProps<TData>>) => {
    const text = toDisplayText(context.getValue());
    return text === null ? (
        <EmptyCellValue empty={meta.empty} />
    ) : (
        <SearchableText
            text={text}
            overflow={meta.overflow}
            table={context.table}
        />
    );
};
